<template>
    <common-content-spacer height="medium">
        <search-list @search="handleSearch"></search-list>
        <template v-if="isLoading && !patientMembers.length">
            <div class="loading-spinner">
                <span>{{ $t('modals.import_contacts_modal.loading') }}</span>
                <loading-spin></loading-spin>
            </div>
        </template>
        <common-grid v-else>
            <template v-if="patientMembers.length">
                <common-grid-column v-for="member in patientMembers" :key="member.id" class="pateint-member-list">
                    <patient-member-card :physician="member"></patient-member-card>
                </common-grid-column>
            </template>
            <template v-else>
                <div class="no-patients">No patients found</div>
            </template>
        </common-grid>
        <div ref="infiniteScrollTrigger" class="infinite-scroll-trigger"></div>
        <template v-if="isInfiniteScrolling">
            <div class="loading-spinner">
                <span>{{ $t('modals.import_contacts_modal.loading') }}</span>
                <loading-spin></loading-spin>
            </div>
        </template>
    </common-content-spacer>
</template>

<script>
    import PatientAPI from 'api/PatientAPI'
    import PatientMemberCard from 'components/page-elements/patient/PatientMemberCard'
    import SearchList from 'components/forms/patient/SearchList'
    import { Circle9 } from 'vue-loading-spinner'

    export default {
        components: {
            PatientMemberCard,
            SearchList,
            'loading-spin': Circle9,
        },

        data() {
            return {
                search: '',
                isLoading: false,
                isInfiniteScrolling: false,
                patientMembers: [],
                fullPatientList: [],
                patientMembersTotalCount: 0,
                offset: 0,
                limit: 20,
                observer: null,
            }
        },

        methods: {
            fetchPatientMembers({ limit, offset, append = false, search }) {
                if (append) {
                    this.isInfiniteScrolling = true
                } else {
                    this.isLoading = true
                }
                const params = {
                    limit,
                    offset,
                }
                if (search) {
                    params.search = search
                }
                PatientAPI.getList(this.$auth.getUser().id, params)
                    .then((res) => {
                        if (append) {
                            this.fullPatientList = this.fullPatientList.concat(res)
                        } else {
                            this.fullPatientList = res
                            this.patientMembersTotalCount = parseInt(res._headers['x-total-count'])
                        }
                        this.patientMembers = this.fullPatientList
                    })
                    .finally(() => {
                        this.isLoading = false
                        this.isInfiniteScrolling = false
                    })
            },

            handleSearch(searchText) {
                this.search = searchText
                this.offset = 0
                if (!searchText || !searchText.trim()) {
                    this.fetchPatientMembers({
                        limit: this.limit,
                        offset: 0,
                    })
                    return
                }
                this.fetchPatientMembers({
                    limit: this.limit,
                    offset: 0,
                    search: searchText,
                })
            },

            loadMore() {
                if (this.isLoading || this.isInfiniteScrolling || this.patientMembers.length >= this.patientMembersTotalCount) {
                    return
                }

                this.offset += this.limit
                this.fetchPatientMembers({
                    limit: this.limit,
                    offset: this.offset,
                    append: true,
                    search: this.search,
                })
            },
            setupIntersectionObserver() {
                this.observer = new IntersectionObserver(
                    ([entry]) => {
                        if (entry.isIntersecting) {
                            this.loadMore()
                        }
                    },
                    {
                        root: null,
                        threshold: 0.1,
                    },
                )

                this.$nextTick(() => {
                    if (this.$refs.infiniteScrollTrigger) {
                        this.observer.observe(this.$refs.infiniteScrollTrigger)
                    }
                })
            },
        },

        created() {
            this.fetchPatientMembers({ limit: this.limit, offset: this.offset })
        },
        mounted() {
            this.setupIntersectionObserver()
        },

        beforeUnmount() {
            if (this.observer) {
                this.observer.disconnect()
            }
        },
    }
</script>
<style>
    @media (max-width: 1366px) {
        .pateint-member-list.grid__column {
            min-height: auto !important;
            padding-left: 27px;
        }
    }
    .no-patients {
        text-align: center;
        font-size: 16px;
        color: #666;
        padding: 20px 0;
        width: 100%;
    }
    .infinite-scroll-trigger {
        height: 1px;
    }
    .loading-spinner {
        text-align: center;
        font-size: 16px;

        .spinner {
            margin: 0 auto;
            zoom: 150%;
        }
    }
</style>
